import { _ } from "libs";

import React from "react";
import Avatar from "../avatar";
import { MatchCreatedActivity, MatchScore } from "../../types";
import { prettyDate } from "../../actions/prettyDate";
import { openPlayerPopup } from "../../actions";

const Player = ({
	activity,
	player,
	score,
}: {
	activity: MatchCreatedActivity;
	player: { [key: string]: null | string };
	score: any; //MatchScore;
}) => {
	let isWinner = activity.match.winnerId == player.userId;
	let playerScore = null;
	if (score) {
		score.map(item => {
			if (item.uuid == player.userId) {
				playerScore = item.score;
			}
		});
	}
	return (
		<div className={`player ${isWinner ? "winner" : ""}`}>
			<div className="user">
				<a onClick={() => openPlayerPopup(player.userId)}>
					<Avatar photoUrl={player.photoUrl} size="thumb5" />
					<div className="name">
						{player.firstName} {player.lastName}
						{isWinner ? <div className="badge winner">{_("winner")}</div> : null}
					</div>
				</a>
			</div>
			<div className="score">
				{playerScore
					? playerScore.map((score, key) => {
							return (
								<div className="value" key={key}>
									{score}
								</div>
							);
					  })
					: null}
			</div>
		</div>
	);
};

const Match = ({ activity }: { activity: MatchCreatedActivity }) => {
	if (!activity.match) {
		return null;
	}
	return (
		<div className="nBlock newsFeedMatch">
			<h5>
				{_("timeline.matchCreated.heading", null, {
					firstName: activity.match.playerA.firstName,
					sport: _(activity.match.details.sport ? "label." + activity.match.details.sport.toLowerCase() : ""),
				})}
			</h5>
			<h5 className="subtitle">
				{prettyDate(activity.match.date, false)}
				{activity.match.club && activity.match.club.clubInfo ? ", " + activity.match.club.clubInfo.name : null}
			</h5>
			<div className="match">
				<Player
					activity={activity}
					player={activity.match.playerA}
					score={activity.match.score ? activity.match.score : null}
				/>
				<Player
					activity={activity}
					player={activity.match.playerB}
					score={activity.match.score ? activity.match.score : null}
				/>
			</div>
		</div>
	);
};

const MatchCreated = ({ activities }: { activities: MatchCreatedActivity[] }) => {
	return (
		<>
			{activities.map((activity, index) => {
				return <Match activity={activity} key={index} />;
			})}
		</>
	);
};

export default MatchCreated;
